<template>
  <section class="text-body-default px-0 pb-1">
    <header class="bg-bgr-primary sticky top-0 z-10 flex items-center gap-2 px-2.5 py-1.5">
      <Icon :src="icon" :size="ComponentSize.lg" />
      {{ title }}
    </header>
    <slot />
  </section>
</template>

<script setup lang="ts">
  import type { SearchResultCategory } from "~/types/search";

  defineOptions({
    name: "GlobalSearchCategory",
  });

  const props = withDefaults(
    defineProps<{
      category?: SearchResultCategory;
    }>(),
    {
      category: "recent" as SearchResultCategory,
    }
  );

  const title = computed(() => {
    return globalSearchCategoryTitle(props.category);
  });

  const icon = computed(() => {
    return globalSearchCategoryIcon(props.category);
  });
</script>
